module.exports = __webpack_public_path__ + "img/redemption-success.a32a42b3.png";